import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "color-container" }
const _hoisted_2 = { class: "color-wrapper" }
const _hoisted_3 = { class: "selected" }
const _hoisted_4 = {
  key: 0,
  class: "arrows"
}
const _hoisted_5 = { class: "selected-name" }
const _hoisted_6 = { class: "editor" }
const _hoisted_7 = {
  key: 0,
  class: "btn filter"
}
const _hoisted_8 = {
  key: 0,
  class: "filter-fill"
}
const _hoisted_9 = {
  key: 1,
  class: "btn"
}
const _hoisted_10 = {
  key: 2,
  class: "btn"
}
const _hoisted_11 = {
  key: 3,
  class: "btn"
}
const _hoisted_12 = {
  key: 4,
  class: "btn"
}
const _hoisted_13 = {
  key: 5,
  class: "btn"
}
const _hoisted_14 = {
  key: 6,
  class: "checkbox"
}
const _hoisted_15 = {
  key: 0,
  class: "popover-filter-fill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_color_card = _resolveComponent("app-color-card")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_editor_canvas = _resolveComponent("app-editor-canvas")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.palettesCards.slice(_ctx.startPalette, _ctx.endPalette), (card) => {
          return (_openBlock(), _createBlock(_component_app_color_card, {
            key: card.id,
            index: _ctx.order(card),
            card: card,
            "is-selected": _ctx.selectedCard?.id === card?.id,
            onSelected: _ctx.selected
          }, null, 8, ["index", "card", "is-selected", "onSelected"]))
        }), 128)),
        (_ctx.palettesCards.length > 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, {
                class: "arrow left",
                size: _ctx.isMobile ? 'sm' : '2xl',
                icon: ['fas', 'arrow-left'],
                onClick: _ctx.nextPalette
              }, null, 8, ["size", "onClick"]),
              _createVNode(_component_font_awesome_icon, {
                class: "arrow right",
                size: _ctx.isMobile ? 'sm' : '2xl',
                icon: ['fas', 'arrow-right'],
                onClick: _ctx.nextPalette
              }, null, 8, ["size", "onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t(_ctx.selectedCard.name)), 1)
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createVNode(_component_app_editor_canvas, {
          ref: "editorCanvasRef",
          "image-url": _ctx.imageUrl,
          "onUpdate:imageUrl": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageUrl) = $event)),
          segments: _ctx.frameColors
        }, null, 8, ["image-url", "segments"])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["buttons", { isMobile: _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_app_button, {
                raised: "",
                severity: "secondary",
                icon: ['fas', 'filter'],
                title: "filter",
                onClick: _ctx.openPaletteSettings
              }, null, 8, ["onClick"]),
              (!_ctx.isCompareFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_app_button, {
                raised: "",
                title: "pickPhoto",
                severity: "secondary",
                icon: ['fas', 'sliders'],
                onClick: _ctx.openImageSettingsModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_app_button, {
                raised: "",
                icon: ['fas', 'camera'],
                severity: "secondary",
                title: "takePhoto",
                onClick: _ctx.openCameraModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "download",
                onClick: _ctx.saveToDevice
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_app_button, {
                severity: "warning",
                title: "saveToGallery",
                loading: _ctx.isSaveToGallery,
                onClick: _ctx.saveToGallery
              }, null, 8, ["loading", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_app_button, {
                severity: "info",
                title: "addSign",
                onClick: _ctx.openImageModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.rememberChoose,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rememberChoose) = $event)),
                label: "rememberChoose"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 7,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.openPaletteSettings }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'filter']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('filter')), 1),
                (!_ctx.isCompareFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageSettingsModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'sliders']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('pickPhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openCameraModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'camera']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('takePhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToDevice }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'download']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToGallery }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'images']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('saveToGallery')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fa-pencil-square']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('addSign')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.rememberChoose,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberChoose) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('rememberChoose')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}